<template>
  <div>
    <component :is="componentName"></component>
  </div>
</template>
<script>
import pcLogin from "./pcLogin.vue";
import mobileLogin from "./mobileLogin.vue";
export default {
  components: {
    pcLogin,
    mobileLogin
  },
  data() {
    return {};
  },
  computed: {
    componentName() {
      return this.$utils.isMobile() ? "mobileLogin" : "pcLogin";
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped></style>
